// extracted by mini-css-extract-plugin
module.exports = {"card":"ResourceCard_card__DcZXU","finger":"ResourceCard_finger__8Y7u_"};